/*
 *
 * Notifier reducer
 * https://github.com/iamhosseindhv/notistack/tree/master/examples/redux-example
 *
 */
import produce from 'immer';
import { ENQUEUE_SNACKBAR, CLOSE_SNACKBAR, REMOVE_SNACKBAR } from './constants';

export const initialState = {
  notifications: [],
};

/* eslint-disable default-case, no-param-reassign */
const notifierReducer = (state = initialState, action) => {
  // const action

  return produce(state, draft => {
    switch (action.type) {
      case ENQUEUE_SNACKBAR:
        draft.notifications = [...draft.notifications, action.notification];
        break;

      case CLOSE_SNACKBAR:
        draft.notifications = draft.notifications.map(noti => {
          const obj =
            action.dismissAll || noti.key === action.key
              ? { ...noti, dismissed: true }
              : { ...noti };

          return obj;
        });
        break;

      case REMOVE_SNACKBAR:
        draft.notifications = [
          ...draft.notifications.filter(notification => notification.key !== action.payload.key),
        ];
        break;
    }
  });
};

export default notifierReducer;
